import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

export default function ShiftIcon(props) {
    return (
        <SvgIcon style={{"fontSize": props.fontSize}}>
            <svg id="Capa_1" x="0px" y="0px" viewBox="0 0 412.879 412.879">
                <g>
                    <g>
                        <path d="M199.982,176.808c-2.065-4.935-7.03-8.097-11.772-10.043l-32.049-14.755l-15.397-12.985l-24.678,24.546l10.333,69.083
			c0.037,0.24-0.024,0.486-0.167,0.682l-10.92,14.943c-0.174,0.238-0.451,0.381-0.746,0.381s-0.572-0.143-0.746-0.381
			l-10.919-14.943c-0.144-0.195-0.203-0.441-0.168-0.682l10.333-69.083l-24.677-24.547L73.012,152.01l-32.048,14.755
			c-4.743,1.946-10.426,6.39-11.773,10.043c0,0-34.834,82.937-15.94,82.937h202.673
			C234.816,259.745,199.982,176.808,199.982,176.808z"/>
                        <path d="M114.585,138.558c32.776,0,57.236-30.539,57.794-81.752C172.734,21.268,155.809,0,114.585,0
			C73.359,0,56.431,21.268,56.793,56.806C57.348,108.019,81.807,138.558,114.585,138.558z"/>
                        <path d="M383.687,329.941c-2.064-4.936-7.03-8.098-11.771-10.043l-32.05-14.756l-15.396-12.984l-24.692,24.562l10.348,69.186
			c0.036,0.238-0.023,0.484-0.167,0.682l-10.92,14.943c-0.174,0.238-0.45,0.379-0.746,0.379c-0.295,0-0.571-0.141-0.745-0.379
			l-10.918-14.943c-0.145-0.195-0.204-0.441-0.168-0.682l10.348-69.186l-24.692-24.562l-15.397,12.984l-32.048,14.756
			c-4.743,1.945-10.207,6.34-11.772,10.043c0,0-34.834,82.938-15.94,82.938h202.674
			C418.521,412.877,383.687,329.941,383.687,329.941z"/>
                        <path d="M240.498,209.939c0.557,51.213,25.015,81.752,57.792,81.752s57.236-30.539,57.795-81.752
			c0.355-35.539-16.57-56.807-57.795-56.807C257.064,153.133,240.135,174.401,240.498,209.939z"/>
                        <path d="M162.375,383.572c-41.489,0-78.795-23.887-96.431-60.586l9.228-1.771c2.342-0.45,4.265-2.112,5.047-4.366
			c0.781-2.252,0.302-4.748-1.259-6.554l-27.263-31.512c-1.28-1.479-3.129-2.308-5.045-2.308c-0.418,0-0.839,0.039-1.259,0.119
			c-2.34,0.449-4.265,2.114-5.047,4.366l-13.663,39.367c-0.781,2.254-0.302,4.751,1.259,6.554c1.56,1.805,3.966,2.639,6.303,2.188
			l11.476-2.202c19.917,46.272,65.62,76.724,116.654,76.724c5.528,0,10.01-4.48,10.01-10.01
			C172.384,388.053,167.903,383.572,162.375,383.572z"/>
                        <path d="M201.348,31.93c41.489,0,78.794,23.886,96.431,60.586l-9.229,1.771c-2.341,0.449-4.266,2.112-5.046,4.365
			c-0.781,2.252-0.303,4.75,1.258,6.554l27.264,31.512c1.279,1.48,3.129,2.307,5.045,2.307c0.418,0,0.839-0.038,1.258-0.119
			c2.342-0.449,4.266-2.114,5.049-4.366l13.662-39.366c0.781-2.253,0.302-4.751-1.259-6.554c-1.56-1.804-3.966-2.639-6.304-2.188
			l-11.475,2.203c-19.918-46.272-65.622-76.724-116.655-76.724c-5.529,0-10.011,4.48-10.011,10.01
			C191.337,27.449,195.819,31.93,201.348,31.93z"/>
                    </g>
                </g>
            </svg>
        </SvgIcon>
    )
}